var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3633 12.8032L11.4347 9.87465C12.1627 8.99927 12.6013 7.87519 12.6013 6.65039C12.6013 3.86538 10.3355 1.59961 7.55066 1.59961C4.76571 1.59961 2.5 3.86538 2.5 6.65039C2.5 9.43522 4.76571 11.7008 7.55066 11.7008C8.77539 11.7008 9.89954 11.2623 10.7749 10.5344L13.7036 13.4629C13.7946 13.5541 13.9141 13.5996 14.0334 13.5996C14.1528 13.5996 14.2723 13.5541 14.3634 13.4629C14.5456 13.2807 14.5456 12.9854 14.3633 12.8032ZM3.43311 6.65039C3.43311 4.37989 5.28022 2.53272 7.55066 2.53272C9.82103 2.53272 11.6681 4.37989 11.6681 6.65039C11.6681 8.9207 9.82103 10.7677 7.55066 10.7677C5.28022 10.7677 3.43311 8.9207 3.43311 6.65039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b693c61daad577214296b699dab2909a.svg";
export { ForwardRef as ReactComponent };